import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=6f3cce5c"
import script from "./Resellers.vue?vue&type=script&lang=js"
export * from "./Resellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports